import React, {
  useState,
  useEffect
} from "react";

import api from "../../api";

import {
  useNavigate
} from "react-router-dom";

function ClientsList() {

  const [clients, setClients] =
    useState([]);

  const [search, setSearch] =
    useState("");

  const [page, setPage] =
    useState(1);

  const itemsPerPage = 8;

  const navigate =
    useNavigate();

  // =====================
  // FETCH
  // =====================

  const fetchClients =
    async () => {

      try {

        const res =
          await api.get(
            "/clients"
          );

        setClients(
          res.data
        );

      } catch (err) {

        console.error(
          "Erreur chargement clients:",
          err
        );

      }
    };

  useEffect(() => {

    fetchClients();

  }, []);

  // =====================
  // DELETE
  // =====================

  const handleDelete =
    async (id) => {

      const raison =
        prompt(
          "Raison de suppression ?"
        );

      if (!raison) {

        return alert(
          "Raison obligatoire"
        );

      }

      if (
        !window.confirm(
          "Confirmer suppression ?"
        )
      ) {
        return;
      }

      if (
        !window.confirm(
          "Confirmer définitivement ?"
        )
      ) {
        return;
      }

      try {

        await api.delete(
          `/clients/${id}`,
          {
            data: {
              raison
            }
          }
        );

        setClients(
          (prev) =>
            prev.filter(
              (c) =>
                c.id !== id
            )
        );

      } catch (err) {

        console.error(
          "Erreur suppression:",
          err
        );

        alert(
          "Erreur lors de la suppression"
        );

      }
    };

  // =====================
  // FILTER
  // =====================

  const filteredClients =
    clients.filter(
      (c) =>
        `${c.nom} ${c.post_nom} ${c.prenom}`
          .toLowerCase()
          .includes(
            search.toLowerCase()
          )
    );

  // =====================
  // PAGINATION
  // =====================

  const totalPages =
    Math.ceil(
      filteredClients.length /
        itemsPerPage
    );

  const startIndex =
    (page - 1) *
    itemsPerPage;

  const currentClients =
    filteredClients.slice(
      startIndex,
      startIndex +
        itemsPerPage
    );

  // =====================
  // RENDER
  // =====================

  return (
    <div className="p-3 md:p-6 space-y-5 min-h-[100dvh] bg-gray-100">

      {/* HEADER */}
      <div className="flex flex-col md:flex-row justify-between md:items-center gap-3">

        <h2 className="text-2xl md:text-3xl font-bold">
          👤 Liste des clients
        </h2>

        <div className="flex flex-wrap gap-2">

          <button
            onClick={() =>
              navigate(
                "/clients/new"
              )
            }
            className="bg-green-600 hover:bg-green-700 transition text-white px-4 py-3 rounded-xl"
          >
            ➕ Ajouter
          </button>

          <button
            onClick={() =>
              navigate(
                "/clients/deleted"
              )
            }
            className="bg-gray-600 hover:bg-gray-700 transition text-white px-4 py-3 rounded-xl"
          >
            📁 Supprimés
          </button>

          <button
            onClick={() =>
              navigate(
                "/dashboard"
              )
            }
            className="bg-indigo-600 hover:bg-indigo-700 transition text-white px-4 py-3 rounded-xl"
          >
            ⬅️ Dashboard
          </button>

        </div>

      </div>

      {/* SEARCH */}
      <input
        type="text"
        placeholder="Rechercher un client..."
        value={search}
        onChange={(e) => {

          setSearch(
            e.target.value
          );

          setPage(1);

        }}
        className="w-full border rounded-2xl px-4 py-3 shadow-sm outline-none focus:ring-2 focus:ring-blue-300"
      />

      {/* MOBILE */}
      <div className="grid gap-3 md:hidden">

        {currentClients.map(
          (c) => (

            <div
              key={c.id}
              className="bg-white rounded-2xl shadow p-4"
            >

              <div
                className="cursor-pointer"
                onClick={() =>
                  navigate(
                    `/clients/${c.id}`
                  )
                }
              >

                <p className="font-semibold text-blue-600 text-lg">
                  {c.nom}{" "}
                  {
                    c.post_nom
                  }{" "}
                  {
                    c.prenom
                  }
                </p>

                <p className="text-sm text-gray-600 mt-1">
                  📞{" "}
                  {
                    c.telephone ||
                    "-"
                  }
                </p>

                <p className="text-sm text-gray-600">
                  🌍{" "}
                  {
                    c.nationalite ||
                    "-"
                  }
                </p>

              </div>

              <div className="flex gap-2 mt-4">

                <button
                  onClick={() =>
                    navigate(
                      `/clients/${c.id}/edit`
                    )
                  }
                  className="flex-1 bg-blue-500 hover:bg-blue-600 transition text-white py-2 rounded-xl"
                >
                  Modifier
                </button>

                <button
                  onClick={() =>
                    handleDelete(
                      c.id
                    )
                  }
                  className="flex-1 bg-red-500 hover:bg-red-600 transition text-white py-2 rounded-xl"
                >
                  Supprimer
                </button>

              </div>

            </div>

          )
        )}

      </div>

      {/* DESKTOP */}
      <div className="hidden md:block bg-white rounded-2xl shadow overflow-x-auto">

        <table className="min-w-full text-sm">

          <thead className="bg-gray-100 text-left">

            <tr>

              <th className="px-4 py-3">
                Nom complet
              </th>

              <th className="px-4 py-3">
                Téléphone
              </th>

              <th className="px-4 py-3">
                Nationalité
              </th>

              <th className="px-4 py-3">
                Actions
              </th>

            </tr>

          </thead>

          <tbody>

            {currentClients.map(
              (c) => (

                <tr
                  key={c.id}
                  className="border-t hover:bg-gray-50"
                >

                  <td
                    className="px-4 py-3 text-blue-600 cursor-pointer hover:underline"
                    onClick={() =>
                      navigate(
                        `/clients/${c.id}`
                      )
                    }
                  >
                    {c.nom}{" "}
                    {
                      c.post_nom
                    }{" "}
                    {
                      c.prenom
                    }
                  </td>

                  <td className="px-4 py-3">
                    {
                      c.telephone
                    }
                  </td>

                  <td className="px-4 py-3">
                    {
                      c.nationalite
                    }
                  </td>

                  <td className="px-4 py-3">

                    <div className="flex gap-2">

                      <button
                        onClick={() =>
                          navigate(
                            `/clients/${c.id}/edit`
                          )
                        }
                        className="bg-blue-500 hover:bg-blue-600 transition text-white px-4 py-2 rounded-xl"
                      >
                        Modifier
                      </button>

                      <button
                        onClick={() =>
                          handleDelete(
                            c.id
                          )
                        }
                        className="bg-red-500 hover:bg-red-600 transition text-white px-4 py-2 rounded-xl"
                      >
                        Supprimer
                      </button>

                    </div>

                  </td>

                </tr>

              )
            )}

          </tbody>

        </table>

      </div>

      {/* PAGINATION */}
      <div className="flex justify-between items-center text-sm">

        <span>
          Page {page} /{" "}
          {totalPages || 1}
        </span>

        <div className="flex gap-2">

          <button
            disabled={
              page === 1
            }
            onClick={() =>
              setPage(
                (p) => p - 1
              )
            }
            className="px-4 py-2 bg-gray-200 rounded-xl disabled:opacity-40"
          >
            ←
          </button>

          <button
            disabled={
              page ===
                totalPages ||
              totalPages === 0
            }
            onClick={() =>
              setPage(
                (p) => p + 1
              )
            }
            className="px-4 py-2 bg-gray-200 rounded-xl disabled:opacity-40"
          >
            →
          </button>

        </div>

      </div>

    </div>
  );
}

export default ClientsList;